import React, { useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import MenuFunzionalita from "./MenuFunzionalita";
import FiltriPerLavoratore from "./FiltriPerLavoratore";
import TabellaOrarioPerLavoratore from "./TabellaOrarioPerLavoratore";
import RipetiSettimana from "./RipetiSettimana";
import { Container, Alert, Button } from "react-bootstrap";
import ElencoNoteAttiveLavoratore from './ElencoNoteAttiveLavoratore';
import { Settimane } from '../helper/settimaneTurniLavoro';
import { buildUrl } from '../helper/handler';
import { getFromApi } from '../utilities/NetUtilities';
import { FaChevronUp, FaChevronRight } from 'react-icons/fa';
import moment from "moment";

function OrarioLavoroLavoratore() {
    const [sedi, setSedi] = useState();
    const [servizi, setServizi] = useState();
    const [message, setMessage] = useState([]);
    const [filtro, setFiltro] = useState(null);
    const [lavoratori, setLavoratori] = useState([]);
    const [refreshSettimaneConTurni, setRefreshSettimaneConTurni] = useState(null);
    const [settimaneOptions, setSettimaneOptions] = useState(Settimane);
    const [showNotes, setShowNotes] = useState(false);
    const [noteAttive, setNoteAttive] = useState([]);

    const history = useHistory();

    useEffect(() => {
        const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        const setLavoratoriFromApi = (data) => {
            setLavoratori(data.lavoratori.map(lavoratore => ({
                "value": lavoratore.id,
                "label": lavoratore.nomeCognome
            })));
        };
        const setServiziFromApi = (data) => {
            setServizi(data.servizi);
        };
        const setSediFromApi = (data) => {
            setSedi(data.sedi);
        };
        const setMessageFromApi = (data) => {
            setMessage(message => [...message, { tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }]);
        };

        if (organizzazioneMap) {
            const urlLavoratori = buildUrl('lavoratori', {
                organizzazione: organizzazioneMap.nome,
                tipo: organizzazioneMap.tipo
            });
            getFromApi(urlLavoratori, setLavoratoriFromApi, setMessageFromApi);
            getFromApi(buildUrl('servizi', { organizzazione: organizzazioneMap.nome, tipo: organizzazioneMap.tipo }), setServiziFromApi, setMessageFromApi);
            getFromApi(buildUrl('sedi', { organizzazione: organizzazioneMap.nome, tipo: organizzazioneMap.tipo }), setSediFromApi, setMessageFromApi);
        }
    }, [filtro]);

    function filtroChanged(newLavoratore, newSettimana) {
        setFiltro({
            lavoratore: newLavoratore,
            settimana: newSettimana
        });
        setMessage([]);
        setShowNotes(false);
        setNoteAttive([]);
    }

    useEffect(() => {
        if (filtro && filtro.lavoratore) {
            const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
            const params = {
                organizzazione: organizzazioneMap.nome,
                tipo: organizzazioneMap.tipo,
                lavoratore: filtro.lavoratore.value
            };
            const url = buildUrl('noteattivelavoratore', params);
            const setNoteFromApi = (data) => {
                setNoteAttive(data.note);
            };
            const setMessageFromApi = (data) => {
                setMessage(message => [...message, { tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }]);
            };
            getFromApi(url, setNoteFromApi, setMessageFromApi);
        }
    }, [filtro, showNotes]);

    const buildSediMap = () => {
        const sediMap = {};
        if (sedi) {
            sedi.forEach(sede => {
                sediMap[sede.id] = sede.descrizione;
            });
        }
        return sediMap;
    };

    const buildLavoratoriMap = () => {
        const lavoratoriMap = {};
        if (lavoratori) {
            lavoratori.forEach(lavoratore => {
                lavoratoriMap[lavoratore.value] = lavoratore.label;
            });
        }
        return lavoratoriMap;
    };

    const handleInviaOrario = () => {
        if (filtro && filtro.lavoratore && filtro.settimana) {
            history.push({
                pathname: '/inviaorariolavoratore',
                state: {
                    lavoratorePassato: filtro.lavoratore,
                    settimanaPassata: filtro.settimana,
                }
            });
        } else {
            setMessage([{ tipo: 'warning', descrizione: 'Selezionare un lavoratore e una settimana prima di inviare l\'orario.' }]);
        }
    };

    return (
        <div className='main' role="main">
            <div>
                <MenuFunzionalita />
                <h1 className="d-flex justify-content-center inEvidenza" id="title_home">
                    Turni di lavoro per lavoratore
                </h1>
                {
                    message && message.map((data, key) => (
                        <Alert variant={data.tipo} id={`message-${key}`} key={key}>
                            {data.descrizione}
                        </Alert>
                    ))
                }
                <Container className="">
                    <FiltriPerLavoratore
                        setMessage={setMessage}
                        filtroChanged={filtroChanged}
                        lavoratori={lavoratori}
                        settimaneOptions = {settimaneOptions}
                        setSettimaneOptions = {setSettimaneOptions}
                        refreshSettimaneConTurni={refreshSettimaneConTurni}
                    />
                </Container>
                {filtro && (
                    <Container fluid>
                        {noteAttive.length > 0 && (
                            <div className="mb-3 mt-3">
                                <Button
                                    variant="flat"
                                    size="sm"
                                    onClick={() => setShowNotes(!showNotes)}
                                    id="note-attive-button"
                                    className="btnGeneraleVariante"
                                >
                                    Note Attive&nbsp;
                                    {showNotes ? <FaChevronUp className="icon-small" /> : <FaChevronRight className="icon-small" />}
                                </Button>
                            </div>
                        )}
                        {showNotes && (
                            <ElencoNoteAttiveLavoratore
                                note={noteAttive}
                                lavoratori={buildLavoratoriMap()}
                                sedi={buildSediMap()}
                            />
                        )}
                    </Container>
                )}
                {filtro && (
                    <Container fluid>
                        <div className="d-flex align-items-center justify-content-end">
                           <RipetiSettimana
                                lavoratore={filtro.lavoratore}
                                settimanariferimento={filtro.settimana}
                                setMessage={setMessage}
                                setRefreshSettimaneConTurni={setRefreshSettimaneConTurni}
                                settimaneOptions={settimaneOptions}
                                settimana={filtro.settimana}
                            />
                            <Button
                                variant="flat"
                                size="sm"
                                onClick={handleInviaOrario}
                                id="invia-orario-button"
                                className="btnGeneraleVariante"
                                title="Invia orario via email"
                            >
                                Invia Orario
                            </Button>
                            <Link to={`/gestioneferiepermessi?lavoratoreid=` + filtro.lavoratore.value + "&lavoratorenome=" +filtro.lavoratore.label 
                                + "&inizio=" + moment(new Date()).format("yyyy-MM-DD")
                            }>
                                <Button key="feriepermessi" id="feriepermessi" type="button" size="sm"
                                    variant='flat' className="btnGeneraleVariante">Ferie/Permessi</Button> 
                            </Link>
                        </div>
                        <TabellaOrarioPerLavoratore
                            setMessage={setMessage}
                            sedi={sedi}
                            servizi={servizi}
                            lavoratore={filtro.lavoratore}
                            settimana={filtro.settimana}
                            setRefreshSettimaneConTurni={setRefreshSettimaneConTurni}
                            lavoratori={lavoratori}
                        />
                    </Container>
                )}
            </div>
        </div>
    );
}

export default OrarioLavoroLavoratore;
